const notificationsInitialState = {
    notifications: [],
    isNotificationsOpen: false
}

export default notificationsInitialState;